export function scrollToElement(
  selector: string,
  arg?: boolean | ScrollIntoViewOptions,
) {
  const element = document.querySelector(selector);
  element?.scrollIntoView(arg);
}
